var Menu = require('models/menu');
var MenuView = require('views/menu/menu-view');
var Controller = require('controllers/base/controller');
var ContentService = require('services/content-service');
var CourseSettingsService = require('services/course-settings-service');
var MenuService = require('services/menu-service');
import { SessionStorageService } from 'services/web-storage-service';
var utils = require('lib/utils');

var MenuController = Controller.extend({
  show: function (params, route, options) {
    SessionStorageService.setItem('queryParams', options.query);
    var defaults = {
      homePage: 'home',
      type: 'module', //module menu
      groups: false, // forces order at the group level.
    };
    var menuSettings = CourseSettingsService.get('menu');
    _.defaults(menuSettings, defaults);

    if (options.query.group) {
      MenuService.currentGroup = EF.groups.find({ id: parseInt(options.query.group) });
    } else {
      MenuService.currentGroup = null;
    }

    var page = params.page || menuSettings.homePage;

    if (CourseSettingsService.get('menuOverride') && page == menuSettings.homePage) {
      let menuOverride = CourseSettingsService.get('menuOverride');
      if (menuOverride && menuOverride.postMessage) {
        window.postMessage({ event_type: menuOverride.postMessage }, window.location.origin);
      } else {
        window.location = menuOverride;
      }
      return;
    }

    var menu = new Menu(menuSettings);
    if (menu.get('skip')) {
      var firstIncomplete = EF.modules.getFirstAvailable(menuSettings);
      if (!firstIncomplete && EF.module === EF.modules.last()) {
        window.postMessage({ event_type: 'close-content' }, window.location.origin);
      } else {
        utils.redirectToModule(firstIncomplete);
      }
    } else {
      menu.set('key', page);

      ContentService.applyContentAndLocale(menu, 'menu.' + page).then(() => {
        if (menu.get('groups') && !EF.enrollment.get('demoMode')) {
          EF.groups.lockGroups(menu.get('lockPastGroups'), MenuService.getUnlockDay());
        }
        MenuService.autoPlay();
        if (Object.isExtensible(this)) {
          this.view = new MenuView({
            className: 'menu ' + page,
            model: menu,
            region: 'main',
          });
        } else {
          return;
        }
      });
    }
  },
});

module.exports = MenuController;
